import { render, staticRenderFns } from "./MotorWithoutVFD.vue?vue&type=template&id=5ce4a51e&scoped=true&"
import script from "./MotorWithoutVFD.vue?vue&type=script&lang=ts&"
export * from "./MotorWithoutVFD.vue?vue&type=script&lang=ts&"
import style0 from "./MotorWithoutVFD.vue?vue&type=style&index=0&id=5ce4a51e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce4a51e",
  null
  
)

export default component.exports